<template>
  <div class="edit_item_font_size edit_item_font_size_new">
    <el-select
  placeholder="请选择"
    v-model="result"
    size="medium"
    class="ml-12"
  >
    <el-option
      v-for="item in $store.state.options.fontSize"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
    <!-- <el-popover placement="bottom" v-clickOutside="outsideClick" :width="width" trigger="manual" v-model="visible" :append-to-body="false">
      <div class="font-size-popover">
        <span
          v-for="(item, index) in $store.state.options.fontSize"
          :key="index"
          :class="{ active: result === item.value }"
          @click="result = item.value"
        >
          <i class="el-icon-check"></i>
          {{ item.value }}
        </span>
      </div>
      <el-input-number
        slot="reference"
        v-model="result"
        controls-position="right"
        @input.native="input_number"
        @change="change_number"
        @keyup.enter.native="change_number"
        @focus="visible = true"
        :min="12"
        :max="128"
        size="small"
        :style="{ width: width + 'px' }"
      ></el-input-number>
    </el-popover> -->
  </div>
</template>

<script>
export default {
  name: 'MyfontSizeNew',
  data() {
    return {
      visible: false,
      result: this.value
    }
  },
  props: {
    width: {
      type: [Number, String],
      default: 60
    },
    title: {
      // 组件的标题
      type: String,
      default: '字号'
    },
    value: {
      type: [Number, String]
    }
  },
  computed: {},
  watch: {
    result(val) {
      // 数据双向绑定
      this.$emit('update:value', val)
      this.$emit('change', val)
    },
    value(val) {
      this.result = val
    }
  },
  methods: {
    outsideClick() {
      this.visible = false
    },
    change_number(number) {
      this.visible = true
      if (this.result < 128) {
        this.result = parseInt(this.result) + 1
      }
      if (this.result > 12) {
        this.result = parseInt(this.result) - 1
      }
    },
    input_number(event) {
      const number = event.target.value
      if (this.isLegalNumber(number)) {
        this.change_number(number)
      }
    },
    isLegalNumber(num) {
      return this.is_int(num)
    },
    is_int(number) {
      // 0和第一位不为0的正整数
      const reg = /^(0|[1-9]\d*)$/
      return reg.test(number)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit_item_font_size_new {
  ::v-deep {
    .el-popover {
      min-width: 60px;
      margin-top: 4px;
      padding: 4px;
      background: #ffffff;
      box-shadow: 0px 10px 32px 0px #e2e2ea;
      border-radius: 4px;
      border: 1px solid #e2e2e2;
    }
    .el-popover__content{
        overflow: hidden;
    }
    .el-select{
        width:100%;
    }
  }
}

.font-size-popover {
  max-height: 260px;
  overflow-y: auto;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.1);
   /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
   scrollbar-width: thin;
   /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
   -ms-overflow-style: none;
  span {
    display: block;
    line-height: 32px;
    cursor: pointer;
    height: 32px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    &.active {
      background: #0086ff;
      border-radius: 4px;
      color: #ffffff;
    }
    .el-icon-check {
      color: #ffffff;
    }
  }
  ::v-deep {
  }
}

.item_title {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
  margin-top: 4px;
  display: inline-block;
  text-align: center;
}
</style>
